import { ExternalStyles, Text } from 'bold-ui'

interface MChatMarcaProps {
  style?: ExternalStyles
}

export function MChatMarca({ style }: Readonly<MChatMarcaProps>) {
  return (
    <Text color='secondary' style={style}>
      © 2009 Robins, Fein, & Barton
    </Text>
  )
}
